import Icon from '../Icon';
import styled from 'styled-components';

interface RoundIconButtonProps {
  iconName: string;
  onClick?: (event: React.MouseEvent) => void;
  currentColor?: boolean;
  notificationCount?: number;
  iconBgColor?: string;
  iconBorderColor?: string;
  iconColor?: string;
  iconSize?: number;
  borderRadius?: string;
  width?: string;
  height?: string;
  noBoxShadow?: boolean;
  disabled?: boolean;
}

const Button = styled.button<{
  $disabled?: boolean;
  $currentColor?: boolean;
  $iconBgColor?: string;
  $iconBorderColor?: string;
  $iconColor?: string;
  $noBoxShadow?: boolean;
  $borderRadius?: string;
  $size?: string;
  $width?: string;
  $height?: string;
  $iconSize?: number;
}>`
  position: relative;
  background-color: ${({ theme, $disabled, $currentColor, $iconBgColor }) => {
    if ($disabled) return theme.color.grey2;
    if ($currentColor) return 'currentColor';
    if ($iconBgColor) return $iconBgColor;
    return 'inherit';
  }};
  border-color: ${({ $currentColor, $iconBorderColor }) => {
    if ($currentColor) return 'currentColor';
    if ($iconBorderColor) return $iconBorderColor;
    return 'transparent';
  }};
  border-width: 0.1rem;
  color: ${({ $currentColor, $iconColor }) => {
    if ($currentColor) return 'currentColor';
    if ($iconColor) return $iconColor;
    return 'inherit';
  }};
  border-radius: ${({ $borderRadius }) => $borderRadius ?? '50%'};
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  display: flex;
  justify-content: center;
  border-style: solid;
  box-shadow: ${({ $noBoxShadow }) =>
    !$noBoxShadow && '0 0 0.3rem rgba(0, 0, 0, 0.25)'};
  cursor: ${({ theme, $disabled }) =>
    $disabled ? theme.color.grey2 : 'pointer'};
`;

const IconStyles = styled.span<{ $iconSize?: number }>`
  font-size: ${({ $iconSize }) => $iconSize}px;
  align-self: center;
  text-align: center;
  cursor: pointer;
`;

function RoundIconButton({
  currentColor,
  iconBgColor,
  onClick,
  width,
  height,
  iconColor,
  iconBorderColor,
  noBoxShadow,
  disabled,
  iconName,
  iconSize,
}: RoundIconButtonProps) {
  return (
    <Button
      $currentColor={currentColor}
      $iconBgColor={iconBgColor}
      onClick={onClick}
      $width={width}
      $height={height}
      $iconColor={iconColor}
      $iconBorderColor={iconBorderColor}
      $noBoxShadow={noBoxShadow}
      $disabled={disabled}
    >
      <IconStyles>
        <Icon name={iconName} size={iconSize} onClick={onClick} />
      </IconStyles>
    </Button>
  );
}

export default RoundIconButton;
